import  { useState } from "react";

const ITEMS_PER_PAGE = 9;

const ServicesGrid = ({ data }) => {
  const [page, setPage] = useState(1);

  const totalPages = Math.ceil(data.length / ITEMS_PER_PAGE);

  const startIndex = (page - 1) * ITEMS_PER_PAGE;
  const currentItems = data.slice(
    startIndex,
    startIndex + ITEMS_PER_PAGE
  );

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6">

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 place-items-center">
          {currentItems.map((item) => (
            <div
              key={item.id}
              className="
                w-[280px] h-[280px]
                bg-white
                border border-gray-200
                rounded-2xl
                p-6
                flex flex-col items-center text-center
                transition-all duration-300
                hover:shadow-lg
                hover:-translate-y-1
              "
            >
              {/* Icon */}
              <div className="w-14 h-14 rounded-full bg-green-100 text-green-700 flex items-center justify-center mb-4">
                {item.icon}
              </div>

              {/* Title */}
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {item.title}
              </h3>

              {/* Description */}
              <p className="text-sm text-gray-600 flex-grow">
                {item.description}
              </p>

              {/* CTA */}
              <button className="mt-4 text-green-700 text-sm font-medium hover:underline">
                Read More →
              </button>
            </div>
          ))}
        </div>

        {/* Pagination */}
        <div className="flex justify-center gap-3 mt-12">
          {Array.from({ length: totalPages }).map((_, index) => {
            const pageNumber = index + 1;
            return (
              <button
                key={pageNumber}
                onClick={() => setPage(pageNumber)}
                className={`px-4 py-2 rounded-md text-sm font-medium border
                  ${
                    page === pageNumber
                      ? "bg-green-700 text-white border-green-700"
                      : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100",
                      window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                `}
              >
                {pageNumber}
              </button>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default ServicesGrid;
